import { useAuth } from "@clerk/react"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useSessionMutation, useSessionQuery } from "../query/authenticated"
import { queryKeys } from "../query/keys"
import type { SystemBattleBotsConfig } from "../schemas"
import {
  fetchPublicSystemBattleBotsFromServer,
  fetchSystemBattleBotsFromServer,
  syncSystemBattleBotsToServer,
} from "./remote"

export function usePublicSystemBattleBotsQuery() {
  return useQuery<SystemBattleBotsConfig | null>({
    queryFn: ({ signal }) => fetchPublicSystemBattleBotsFromServer(signal),
    queryKey: queryKeys.system.battleBots(),
  })
}

export function useSystemBattleBotsQuery() {
  const { userId } = useAuth()
  return useSessionQuery<SystemBattleBotsConfig | null>({
    queryFn: ({ sessionToken, signal }) =>
      fetchSystemBattleBotsFromServer(sessionToken, signal),
    queryKey: queryKeys.admin.systemBattleBots(userId),
  })
}

export function useSyncSystemBattleBotsMutation() {
  const { userId } = useAuth()
  const queryClient = useQueryClient()
  const queryKey = queryKeys.admin.systemBattleBots(userId)

  return useSessionMutation({
    mutationFn: (record: SystemBattleBotsConfig, { sessionToken }) =>
      syncSystemBattleBotsToServer(record, sessionToken),
    onSuccess: (synced) => {
      queryClient.setQueryData(queryKey, synced)
    },
  })
}
